import React from 'react';
import { CountdownTimer } from './CountdownTimer';
export function FinalCTA() {
  return <section className="w-full bg-black py-20 px-4" data-id="element-105">
      <div className="max-w-4xl mx-auto text-center" data-id="element-106">
        {/* Logo */}
        <div className="text-[#00B4D8] text-3xl font-black tracking-widest mb-8" data-id="element-107">
          🎾 EDULABS™
        </div>

        <h2 className="text-2xl sm:text-3xl font-bold text-white mb-3" data-id="element-108">
          El próximo lunes podés volver a improvisar la clase.
        </h2>
        <p className="text-[#00B4D8] text-2xl sm:text-3xl font-black mb-10" data-id="element-109">
          O podés entrar a la cancha con todo resuelto desde hoy.
        </p>

        {/* Cost Table */}
        <div className="bg-[#001a2d] border border-[#00B4D8]/30 rounded-2xl overflow-hidden mb-12 max-w-2xl mx-auto text-left" data-id="element-110">
          <div className="p-4 bg-[#000d1a] border-b border-[#00B4D8]/30 text-center font-bold text-white" data-id="element-111">
            ¿Cuánto cuesta NO tenerlo?
          </div>
          <div className="grid grid-cols-1 sm:grid-cols-2 bg-[#000d1a] border-b border-[#00B4D8]/30" data-id="element-112">
            <div className="p-4 font-bold text-gray-400 text-center" data-id="element-113">
              Sin EDULABS
            </div>
            <div className="p-4 font-bold text-[#00B4D8] text-center sm:border-l border-[#00B4D8]/30" data-id="element-114">
              Con EDULABS
            </div>
          </div>
          <div className="grid grid-cols-1 sm:grid-cols-2 border-b border-gray-800" data-id="element-115">
            <div className="p-4 text-gray-400 text-sm" data-id="element-116">
              100+ horas/año planificando desde cero
            </div>
            <div className="p-4 text-white font-bold text-sm bg-[#00B4D8]/5 sm:border-l border-gray-800" data-id="element-117">
              10 min/semana. El resto es enseñar.
            </div>
          </div>
          <div className="grid grid-cols-1 sm:grid-cols-2 border-b border-gray-800" data-id="element-118">
            <div className="p-4 text-gray-400 text-sm" data-id="element-119">
              Drills improvisados → mismo error por meses
            </div>
            <div className="p-4 text-white font-bold text-sm bg-[#00B4D8]/5 sm:border-l border-gray-800" data-id="element-120">
              120 consignas listas → se resuelve en la clase
            </div>
          </div>
          <div className="grid grid-cols-1 sm:grid-cols-2 border-b border-gray-800" data-id="element-121">
            <div className="p-4 text-gray-400 text-sm" data-id="element-122">
              60% de abandono antes del año
            </div>
            <div className="p-4 text-white font-bold text-sm bg-[#00B4D8]/5 sm:border-l border-gray-800" data-id="element-123">
              Sistema de fidelización → retención +80%
            </div>
          </div>
          <div className="grid grid-cols-1 sm:grid-cols-2 border-b border-gray-800" data-id="element-124">
            <div className="p-4 text-gray-400 text-sm" data-id="element-125">
              Sin progresión clara por nivel
            </div>
            <div className="p-4 text-white font-bold text-sm bg-[#00B4D8]/5 sm:border-l border-gray-800" data-id="element-126">
              6 tomos con categorías → suben y recomiendan
            </div>
          </div>
          <div className="grid grid-cols-1 sm:grid-cols-2 border-b border-gray-800" data-id="element-127">
            <div className="p-4 text-gray-400 text-sm" data-id="element-128">
              Lluvia = cancelación = sin cobro
            </div>
            <div className="p-4 text-white font-bold text-sm bg-[#00B4D8]/5 sm:border-l border-gray-800" data-id="element-129">
              Plan B Lluvia: 20 circuitos listos para indoor
            </div>
          </div>
          <div className="grid grid-cols-1 sm:grid-cols-2 border-b border-gray-800" data-id="element-130">
            <div className="p-4 text-gray-400 text-sm" data-id="element-131">
              Niveles mezclados = caos
            </div>
            <div className="p-4 text-white font-bold text-sm bg-[#00B4D8]/5 sm:border-l border-gray-800" data-id="element-132">
              Plantillas listas → todos mejoran juntos
            </div>
          </div>
          <div className="grid grid-cols-1 sm:grid-cols-2 border-b border-gray-800" data-id="element-133">
            <div className="p-4 text-gray-400 text-sm" data-id="element-134">
              Cobro irregular e incómodo
            </div>
            <div className="p-4 text-white font-bold text-sm bg-[#00B4D8]/5 sm:border-l border-gray-800" data-id="element-135">
              Abono blindado → cobro el día 25-30
            </div>
          </div>
          <div className="grid grid-cols-1 sm:grid-cols-2 border-b border-gray-800" data-id="element-136">
            <div className="p-4 text-gray-400 text-sm" data-id="element-137">
              Sin identidad profesional
            </div>
            <div className="p-4 text-white font-bold text-sm bg-[#00B4D8]/5 sm:border-l border-gray-800" data-id="element-138">
              Sistema de negocio que justifica cobrar más
            </div>
          </div>
          <div className="grid grid-cols-1 sm:grid-cols-2" data-id="element-139">
            <div className="p-4 text-gray-400 text-sm" data-id="element-140">
              Contrato verbal que termina en conflicto
            </div>
            <div className="p-4 text-white font-bold text-sm bg-[#00B4D8]/5 sm:border-l border-gray-800" data-id="element-141">
              Reglamento + Deslinde Ético listos para usar
            </div>
          </div>
        </div>

        {/* Countdown */}
        <div className="mb-4" data-id="element-142">
          <p className="text-white font-bold mb-4" data-id="element-143">
            ⏰ El precio de lanzamiento cierra en:
          </p>
          <CountdownTimer size="lg" blinking={true} data-id="element-144" />
        </div>
        <p className="text-gray-300 text-sm mb-12" data-id="element-145">
          Después sube <span className="text-[#FF0000] font-bold" data-id="element-146">USD 5</span> y
          no vuelve.
        </p>

        {/* 2 mini pricing cards */}
        <div className="grid grid-cols-1 sm:grid-cols-2 gap-6 mb-10 max-w-2xl mx-auto" data-id="element-147">
          <div className="bg-[#0a0a0a] border border-[#00B4D8]/30 rounded-xl p-6 text-center flex flex-col" data-id="element-148">
            <div className="text-2xl mb-2" data-id="element-149">📘</div>
            <h3 className="text-white font-black mb-1" data-id="element-150">MEGAPACK TENIS LISTO</h3>
            <p className="text-gray-400 text-xs mb-4" data-id="element-151">6 Tomos + 6 Bonos</p>
            <div className="mt-auto" data-id="element-152">
              <p className="text-gray-400 line-through text-sm mb-1" data-id="element-153">
                Antes: USD 24,90
              </p>
              <p className="text-[#00B4D8] text-2xl font-black mb-4" data-id="element-154">
                Hoy: USD 13,90
              </p>
              <a href="https://docentes2.edulabs.online/cart/43242368270454:1" className="btn-green-pulse block bg-[#00B4D8] font-black py-4 rounded-lg hover:bg-[#38BDF8] transition-colors text-sm text-[#FFFFFF]" data-id="element-155">
                → QUIERO MI MEGAPACK
              </a>
            </div>
          </div>

          <div className="bg-[#000d1a] border-2 border-[#00B4D8] rounded-xl p-6 text-center shadow-[0_0_30px_rgba(0,180,216,0.2)] flex flex-col" data-id="element-156">
            <div className="text-2xl mb-2" data-id="element-157">🏆</div>
            <h3 className="text-[#00B4D8] font-black mb-1" data-id="element-158">
              MEGAPACK + ACADEMIA PRO ⭐
            </h3>
            <p className="text-gray-400 text-xs mb-1" data-id="element-159">La más elegida</p>
            <p className="text-gray-400 text-xs mb-4" data-id="element-160">
              6 Tomos + 6 Bonos + Academia Pro™
              <br data-id="element-161" />
              (cobro, captación, retención y negocio)
            </p>
            <div className="mt-auto" data-id="element-162">
              <p className="text-gray-400 line-through text-sm mb-1" data-id="element-163">
                Antes: USD 31,90
              </p>
              <p className="text-[#00B4D8] text-3xl font-black mb-4" data-id="element-164">
                Hoy: USD 19,90
              </p>
              <a href="https://docentes2.edulabs.online/cart/43242368893046:1" className="btn-green-pulse block bg-[#00B4D8] font-black py-4 rounded-lg hover:bg-[#38BDF8] transition-colors text-sm text-[#FFFFFF]" data-id="element-165">
                → QUIERO EL MEGAPACK + ACADEMIA PRO
              </a>
            </div>
          </div>
        </div>

        {/* Final trust bar */}
        <div className="flex flex-wrap items-center justify-center gap-3 text-sm text-gray-300" data-id="element-166">
          <span data-id="element-167">🔒 Pago 100% seguro</span>
          <span data-id="element-168">⚡ Acceso en 5 minutos</span>
          <span data-id="element-169">🛡️ Garantía 7 días sin preguntas</span>
          <span data-id="element-170">💳 Tarjeta | PayPal | Transferencia</span>
        </div>
      </div>
    </section>;
}